import FeatureCard from '../components/FeatureCard';
import ModernPropertyDropdown from '../modern/PropertyDropdown';
import PropertyDropdown from '../components/PropertyDropdown';
import { getMinutes } from '../../../../../../../utils/constantValues';

const SensorTimingCluster = ({
    fadingInTime,
    holdUpTime,
    fadingOutTime,
    handleChange,
    className,
    variant,
    style
}) => {
    const Dropdown = variant === 'modern' ? ModernPropertyDropdown : PropertyDropdown;
    return (
        <FeatureCard title="Sensor Timing" className={className} style={style} variant={variant} bodyLayout="fields">
            <Dropdown
                property={fadingInTime}
                properties={fadingInTime.valueMeta.availableValues.sort((a, b) => parseInt(a) - parseInt(b))}
                propertyDisplayFunc={getMinutes}
                title={fadingInTime.info.displayName + ' [1]'}
                measureUnit={'mm:ss'}
                titleSize={5}
                dropdownSize={4}
                unitSize={1}
                handleChange={handleChange} />
            <Dropdown
                property={holdUpTime}
                properties={holdUpTime.valueMeta.availableValues.sort((a, b) => parseInt(a) - parseInt(b))}
                propertyDisplayFunc={getMinutes}
                title={holdUpTime.info.displayName + ' [2]'}
                measureUnit={'mm:ss'}
                titleSize={5}
                dropdownSize={4}
                unitSize={1}
                handleChange={handleChange} />
            <Dropdown
                property={fadingOutTime}
                properties={fadingOutTime.valueMeta.availableValues.sort((a, b) => parseInt(a) - parseInt(b))}
                propertyDisplayFunc={getMinutes}
                title={fadingOutTime.info.displayName + ' [3]'}
                measureUnit={'mm:ss'}
                titleSize={5}
                dropdownSize={4}
                unitSize={1}
                handleChange={handleChange} />
        </FeatureCard>
    );
};

export default SensorTimingCluster;
